import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
const SlideTitle = ({
  slide,
  shouldAnimate,
  gutterBottom,
  style
}) => {
  const {
    title,
    backgroundColor,
    titleColor,
    titleFontSize,
    id
  } = slide;
  const titleSize = titleFontSize || "21px";
  return /*#__PURE__*/React.createElement(Fade, {
    direction: "down",
    in: true,
    timeout: 500,
    style: {
      transitionDelay: "0.3s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h6",
    style: {
      ...{
        color: titleColor,
        backgroundColor,
        fontSize: titleSize
      },
      ...style
    },
    component: "span",
    id: `hiwTitle-${id}`,
    gutterBottom: gutterBottom
  }, title));
};
export default SlideTitle;
SlideTitle.propTypes = {
  shouldAnimate: PropTypes.bool,
  slide: PropTypes.object.isRequired,
  gutterBottom: PropTypes.bool,
  style: PropTypes.object
};